import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {  Form } from "semantic-ui-react";
import { AddBtn } from "../../../commonComponents/AddBtn";
import { CustomLoader } from "../../../commonComponents/formComponents/loader";
import { FormTitle } from "../../../commonComponents/FormTitle";
import List from "../../../commonComponents/List";
import { useMultipleMerchandiseItem } from "../../hooks/useMultipleMerchandiseItem";
import PreviciousDocumentsDetails from "./previciousDocumentsDetails";

function PreviciousDocuments(props) {
  const {
    merchandiseId,
    lineItemIndex,
    invoiceIndex,
    invoiceId,
    isFormDisabled,
    translate,
    jobWheels
  } = props;
  
  
  const previousDocumentInfo = useSelector((state)=>state.InvoicesReducer.invoices.find(invoice=>invoice.invoiceId===invoiceId).
  merchandiseList.find(merch=>merch.merchandiseId===merchandiseId).previousDocumentInfo)

  
  const {
    isLoading,
    AddItem,
    deleteItem,
    updateItem,
    saveItem,
    copyData
  } = useMultipleMerchandiseItem({tableName:"previousDocumentInfo",fieldIdName:"infoId",invoiceId,merchandiseId})

  const status =jobWheels.ES_CUSTOM_JOB_WHEEL?.value?.state
  const formDisabled = (status.includes("BOX_40_REQUIRED") || status.includes("BOX_40_FAILED")) ? false : isFormDisabled;

  const renderItem = useCallback((item,index)=>{
    return (
     <PreviciousDocumentsDetails
     key={item.infoId}
     item={item}
     infoIndex={index}
     deleteItem={deleteItem}
     updateItem={updateItem}
     saveItem={saveItem}
     copyData={copyData}
     lineItemIndex={lineItemIndex}
     invoiceIndex={invoiceIndex}
     translate={translate}
     isFormDisabled={formDisabled}
     />
    )
  },[translate,updateItem,saveItem,deleteItem,copyData,lineItemIndex,invoiceIndex])

  return (
 
    <Form.Group className='float-container mb-2'>
    <FormTitle boxNumber="40" title={translate('CARGO_PRECEEDINGS_DOCS', { ns: ['default', 'lineItem'] })}></FormTitle>
    <List dataSource={previousDocumentInfo} renderItem={renderItem} />
     {isLoading && <CustomLoader />}
           {previousDocumentInfo?.length < 1 && (
           <AddBtn disabled={(formDisabled)} 
           onClick={()=>AddItem({"infoId": "",merchandiseId, invoiceId , "shipmentId":window.shipmentId})}
           text='Add'></AddBtn>
         )}
     </Form.Group>
  );
}

export default React.memo(PreviciousDocuments)
